import React, { useState } from "react"
import { UseData } from "../../../hooks/useReactQuery"
import { Button, Spin, Tag, Popconfirm, Image } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import { getImagePath } from "../../../utils/uri"
import API from "../../../helper/api"
import { openNotification } from "../../../utils/notification"
import { useQueryClient } from "react-query"

const fallBackImag =
  "data:image/png;base64,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"

export default function Delete({ selectedOption, setSelectedOption }) {
  const [visible, setVisible] = useState(0)
  const [loading, setLoading] = useState([])
  const { data, isLoading, refetch, isRefetching, isError } = UseData(
    `variations-${selectedOption.baseProduct._id}`,
    `base-product/variation/${selectedOption.baseProduct._id}`
  )

  const queryClient = useQueryClient()

  if (isError) return "Error"
  if (isLoading) return <Spin />

  const confirm = async (id, varationId) => {
    let path = `base-product/variation/${selectedOption.baseProduct._id}/${id}`
    if (varationId) path = `base-product/variation/${selectedOption.baseProduct._id}/${varationId}/${id}/`
    setLoading((prev) => [...prev, id])

    const [res, error] = await new API({}).delete(path)
    if (res.status === "fail" || res.status === "error") {
      return openNotification("Error", error.message)
    }
    queryClient.setQueryData([`variations-${selectedOption.baseProduct._id}`], [...res.data])
    openNotification("Success", "Successfully deleted")
    setLoading([])
  }

  return (
    <>
      <Button type="primary" onClick={refetch} loading={isLoading || isRefetching}>
        Refetch
      </Button>
      {data.length === 0 ? (
        <div className="py-10 text-base">no data found</div>
      ) : (
        <div className="my-5 overflow-hidden relative">
          {isRefetching || isLoading ? (
            <div className="absolute top-0 left-0 z-20 bg-white/60 inset-0 flex justify-center items-center">
              <Spin size="large" />
            </div>
          ) : null}
          <ul className="list-none p-0 m-0 space-y-4">
            {data?.map((d, i) => (
              <li className="bg-gray-100 rounded-md last:border-b-none text-lg font-bold relative pr-10" key={`v-delete-${i}`}>
                <div className="capitalize cursor-pointer p-4" onClick={() => setVisible(i)}>
                  {d.name}
                </div>
                {d.items.length === 0 && <div className="p-4 text-sm">No Itme found.</div>}
                {visible === i && (
                  <div className="flex p-4 pt-1 flex-wrap">
                    {d?.items.map((item, i) => (
                      <Tag color="blue" key={`v-delete-item-${i}`} className="p-2 text-base flex flex-col space-y-3">
                        <span className=" capitalize">{item.name}</span>
                        <Image width={120} height={120} src={getImagePath(item?.images?.medium?.name)} fallback={fallBackImag} />
                        <Popconfirm
                          placement="topLeft"
                          title={`Are you sure you want to delete ${d.name} ${item.name}?`}
                          description={`You about are deleting ${item.name}`}
                          onConfirm={() => confirm(item._id, d._id)}
                          okText="Yes"
                          cancelText="No"
                          okButtonProps={{ loading: loading.find((l) => l === d._id) }}
                        >
                          <Button
                            type="primary"
                            danger
                            size="small"
                            icon={<DeleteOutlined className="text-md" />}
                            loading={loading.find((l) => l === d._id)}
                          >
                            Delete
                          </Button>
                        </Popconfirm>
                      </Tag>
                    ))}
                  </div>
                )}
                <Popconfirm
                  placement="topLeft"
                  title={`Are you sure you want to delete ${d.name}?`}
                  description={`You about are deleting ${d.name} and all the variation inside it.`}
                  onConfirm={() => confirm(d._id)}
                  okText="Yes"
                  cancelText="No"
                  okButtonProps={{ loading: loading.find((l) => l === d._id) }}
                >
                  <Button
                    shape="circle"
                    danger
                    size="big"
                    className="absolute top-1/2 -translate-y-1/2 right-4 -mt-4"
                    loading={loading.find((l) => l === d._id)}
                  >
                    {!loading.find((l) => l === d._id) && <DeleteOutlined className="text-md" />}
                  </Button>
                </Popconfirm>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
